import { CRISIS_CONTACTS, CRISIS_NOTICE_HEADING } from "@/lib/crisis-notice";

/** Fixed crisis-contact notice for psychiatry pages and profiles. Coral is reserved for exactly this kind of urgency. */
export function CrisisNotice({ className = "" }: { className?: string }) {
  return (
    <aside role="note" aria-label="Mental health crisis contacts" className={`ds-crisis ${className}`.trim()}>
      <h2 className="ds-title">{CRISIS_NOTICE_HEADING}</h2>
      <ul className="ds-crisis__list">
        {CRISIS_CONTACTS.map((contact) => (
          <li key={contact.dial}>
            <span>{contact.label}</span>
            <a className="ds-num" href={`tel:${contact.dial}`}>{contact.number}</a>
            {contact.note ? <span className="ds-fine">{contact.note}</span> : null}
          </li>
        ))}
      </ul>
      <p className="ds-fine">PulseBoard is a referral directory, not a crisis service.</p>
    </aside>
  );
}
